export default __webpack_public_path__ + "static/media/4.322fe364.png";